module.exports = __webpack_public_path__ + "img/stripe.33630174.png";